import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/mute/setMute/uptime.setMute.mutation.gql"
import type {
  UptimeSetMuteMutation,
  UptimeSetMuteMutationVariables,
} from "@/v2-backoffice-client/uptime/mute/setMute/__types__/uptime.setMute.mutation"

type Options = MutationHookOptions<
  UptimeSetMuteMutation,
  UptimeSetMuteMutationVariables
>

// useUptimeSetMuteMutation upserts a mute on a single uptime target.
// Apollo's normalised cache will replace the matching UptimeTarget by
// (Source, Identifier) automatically so the polling UptimeQuery picks
// up the new IsMuted state without a full refetch.
export function useUptimeSetMuteMutation(options?: Options) {
  return useMutation<UptimeSetMuteMutation, UptimeSetMuteMutationVariables>(
    mutation,
    options,
  )
}
